'use client';

import { useEffect } from 'react';

import { ErrorState } from '@/shared/components/ui/common/ErrorState';
import { reportError } from '@/shared/utils/reportError';

/**
 * Top-level (root segment) error boundary. Catches render errors from any page
 * that does not declare its own `error.tsx`. It does NOT catch errors in the
 * root layout itself — `global-error.tsx` handles those.
 */
export default function RootError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    reportError(error, { boundary: 'error', segment: 'root' });
  }, [error]);

  return <ErrorState onReset={reset} />;
}
